import { AppLogo } from '@/assets/icons/AppLogo';
import { Tooltip } from '@/components/ui/Tooltip';
import { cn } from '@/lib/utils';

/** The Littlebird mark, on what Littlebird added when the user asked. */
export const AgentMark = ({
  label = 'Added by Littlebird',
  className,
}: {
  label?: string;
  className?: string;
}) => (
  <Tooltip label={label} side="top" delayDuration={200}>
    <span
      role="img"
      aria-label={label}
      className={cn('inline-flex text-foreground-subtle', className)}
    >
      <AppLogo size={12} customColor="currentColor" decorative />
    </span>
  </Tooltip>
);
